import { render, staticRenderFns } from "./Requests.vue?vue&type=template&id=4dadfcda&scoped=true"
import script from "./Requests.vue?vue&type=script&lang=ts"
export * from "./Requests.vue?vue&type=script&lang=ts"
import style0 from "./Requests.vue?vue&type=style&index=0&id=4dadfcda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dadfcda",
  null
  
)

export default component.exports